export default "__VITE_ASSET__C$q44yWH__"